import { render, staticRenderFns } from "./VehiclesExcludedFromDashboard.vue?vue&type=template&id=be0f2538&scoped=true&"
import script from "./VehiclesExcludedFromDashboard.vue?vue&type=script&lang=js&"
export * from "./VehiclesExcludedFromDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0f2538",
  null
  
)

export default component.exports